<template>
  <div id="app" class="app pxtovw-ignore">
    <router-view />
  </div>
</template>

<style>
.app.pxtovw-ignore {
  font-size: 16px;
}
</style>
<script>
import { isSetting } from "@/common/sbase";
console.log(789);
if (!isSetting) {
  window.$sk && window.$sk.loading.show();
}
import { agentType } from "../stempcore/src/sbase.js";

export default {
  mounted: function () {
    if (agentType() != "wxWork") {
      const script1 = document.createElement("script");
      script1.setAttribute("type", "text/javascript");
      script1.setAttribute("referrerpolicy", "origin");
      script1.setAttribute(
        "src",
        "https://res.wx.qq.com/open/js/jweixin-1.6.0.js"
      );
      document.body.appendChild(script1);
    } else {
      const script1 = document.createElement("script");
      script1.setAttribute("type", "text/javascript");
      script1.setAttribute("referrerpolicy", "origin");
      script1.setAttribute(
        "src",
        "https://res.wx.qq.com/open/js/jweixin-1.2.0.js"
      );
      document.body.appendChild(script1);
    }
  }
};
</script>
